import {
    Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges
} from '@angular/core';
import { GlobalSetting } from '../common-services/global-setting.service';
import { Utility } from './../utils/utility';

declare var $: any;

@Directive({
    selector: '[appAfDatepicker]',
    outputs: ['ngModelChange']
})
export class AfDatepickerDirective implements OnInit, OnChanges, OnDestroy {
    dateValue: any;
    isLoaded = false;
    date =new Date();
    dateLimit:Date= new Date(this.date.getFullYear() +5, this.date.getMonth() ,this.date.getDate());
    @Input() format = '';
    @Input() dateTime = 'true';
    @Input() defaultValue: Date;
    @Input() showCalender: boolean;
    @Input() isOnlyTime: boolean;
    @Input() selectedDate: string;
    @Input() startDate = new Date;
    @Input() isInline = false;
    @Input() defaultTime: string;
    @Input() defaultDate: string;
    @Input() disableNextMonthDates: boolean;
    @Input() isShowWeek: boolean = false;
    @Input() step = 15;
    @Input() formatDate = '';
    @Input() disabledDates: Array<string> = new Array<string>();
    @Input() allowTimes: Array<string> = new Array<string>();
    @Input() hourElement: ElementRef = null;
    @Input() minuteElement: ElementRef = null;
    @Input() endDate : Date=this.dateLimit;
    @Output() hoursMinuteOutput = new EventEmitter<string>();
    @Output() OnSelect = new EventEmitter<any>();
    @Output() OnChangeMonthYear = new EventEmitter<any>();
    @Output() OnCalenderShown = new EventEmitter<any>();
    @Output() OnGenerate = new EventEmitter<any>();
    ngModelChange = new EventEmitter();

    private datepickerOptions: any = {
        format: this.format,
        timepicker: (this.dateTime.toString() === 'true'),
        datepicker: true,
        inline: false,
        scrollMonth : false,
	    scrollInput : false,
        minDate: this.startDate,
        maxDate:this.endDate,
        weeks: true,
        // minDate: '0',
        step: this.step,
        showCalender: false,
        //  todayButton: this.todayButton
    };
    public $el: any;

    constructor(private el: ElementRef, private globalSetting:GlobalSetting,) {
        this.$el = $(el.nativeElement);
        this.format = this.globalSetting.getDateFormat();
    }
    ngOnDestroy(): void {
        if (this.$el) {
            this.$el.datetimepicker('destroy');
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        let isChange = false;
        if (changes.disabledDates && !changes.disabledDates.firstChange) {
            this.disabledDates = changes.disabledDates.currentValue ? changes.disabledDates.currentValue : [];
            this.datepickerOptions.disabledDates = this.disabledDates;
            isChange = true;
        }
        if (changes.defaultDate && !changes.defaultDate.firstChange) {
            this.defaultDate = changes.defaultDate.currentValue ? changes.defaultDate.currentValue : [];
            this.datepickerOptions.value = this.defaultDate;
            isChange = true;
        }
        if (changes.allowTimes && !changes.allowTimes.firstChange) {
            this.allowTimes = changes.allowTimes.currentValue ? changes.allowTimes.currentValue : null;
            this.datepickerOptions.allowTimes = this.allowTimes;
            isChange = true;
        }
        if (changes.startDate) {
            this.startDate = changes.startDate.currentValue ? Utility.getDateStringToDate(changes.startDate.currentValue) : null;
            this.datepickerOptions.minDate = this.startDate;
            isChange = true;
        }
        if (changes.endDate) {
            this.endDate = changes.endDate.currentValue ? Utility.getDateStringToDate(changes.endDate.currentValue) : null;
            this.datepickerOptions.maxDate = this.endDate;
            isChange = true;
        }
        if (isChange) {
            this.$el.datetimepicker(this.datepickerOptions);
        }
    }

    ngOnInit(): void {
        this.datepickerOptions.dayOfWeekStart = 1;
        if (this.startDate) {
            this.datepickerOptions.minDate = this.startDate;
        }
        if(!this.isShowWeek){
            this.datepickerOptions.weeks = this.isShowWeek;
        }
        // this.datepickerOptions.disabledDates = [];
        this.datepickerOptions.disabledDates = this.disabledDates;
        this.datepickerOptions.timepicker = (this.dateTime || this.dateTime.toString() === 'true');
        // this.datepickerOptions.timepicker = false;
        this.datepickerOptions.inline = this.isInline;
        // this.datepickerOptions.todayButton = this.todayButton;
        if (this.defaultDate) {
            this.datepickerOptions.value = this.defaultDate;
        }
        if (this.selectedDate !== null && this.selectedDate !== '') {
            this.datepickerOptions.startDate = this.selectedDate;
        }
        if (this.endDate) {
            this.datepickerOptions.maxDate = this.endDate;
        }
        if (this.dateTime.toString() === 'true') {
            this.datepickerOptions.timepicker = true;
            this.format = 'd.m.Y H:i';
            if (this.defaultTime) {
                this.datepickerOptions.defaultTime = this.defaultTime;
            }
        }
        if (this.isOnlyTime) {
            this.format = 'H:i';
            this.datepickerOptions.timepicker = true;
            this.datepickerOptions.step = this.step;
            this.datepickerOptions.datepicker = false;
            this.datepickerOptions.closeOnTimeSelect = true;
            this.datepickerOptions.closeOnDateSelect = true;
            this.datepickerOptions.validateOnBlur = false;
            if (this.allowTimes.length > 0) {
                this.datepickerOptions.allowTimes = this.allowTimes;
            }
        }
        this.datepickerOptions.format = this.format;
        if (this.formatDate !== '') {
            this.datepickerOptions.formatDate = this.formatDate;
        }
        if (!this.isOnlyTime) {
            //   this.datepickerOptions.monthChangeSpinner = false;
            if (this.formatDate !== '') {
                this.datepickerOptions.formatDate = this.formatDate;
            }
            this.datepickerOptions.onChangeMonth = (evt, ele) => {
                const mm = evt.getMonth() + 1;
                const dd = evt.getDate();
                const yy = evt.getFullYear();
                this.selectedDate = yy + '/' + mm + '/' + dd;
                if (this.selectedDate != null && this.selectedDate !== '') {
                    this.datepickerOptions.startDate = this.selectedDate;
                }
                // this.$el.datetimepicker('hide');
                setTimeout(() => {
                    this.OnChangeMonthYear.emit(evt);
                }, 100);
                return true;
            };
            this.datepickerOptions.onShow = (evt, element) => {
                setTimeout(() => {
                    this.OnCalenderShown.emit(evt);
                }, 50);
            };
        }
        this.datepickerOptions.onSelectDate = (date: Date) => {
            const dateText = this.$el.val();
            this.ngModelChange.emit(dateText);
            this.OnSelect.emit(date.toString());
            if (this.dateTime.toString() !== 'true') {
                this.$el.datetimepicker('hide');
            }
            // $('.xdsoft_datetimepicker').hide();
        };
        this.datepickerOptions.onSelectTime = (time: Date) => {
            const dateTimeText = this.$el.val();
            if (this.dateTime.toString() === 'true') {
                this.ngModelChange.emit(dateTimeText);
                this.OnSelect.emit(dateTimeText);
                this.$el.datetimepicker('hide');
            } else {
                this.hoursMinuteOutput.emit(dateTimeText);
                this.$el.datetimepicker('hide');
            }
            // $('.xdsoft_datetimepicker').hide();
        };
        this.datepickerOptions.onGenerate = (date: Date) => {
            if (this.disableNextMonthDates) {
                $('.xdsoft_date.xdsoft_other_month').addClass('xdsoft_disabled');
            }
            this.OnGenerate.emit(date.toString());
        };
        this.ManageLanguage();
        this.$el.datetimepicker(this.datepickerOptions);
        this.isLoaded = true;
    }

    private ManageLanguage(): void {
        this.datepickerOptions.lang = 'en';
        this.LoadDatepicker();
    }

    private LoadDatepicker(): void {
        if (this.isLoaded && this.$el) {
            this.$el.datetimepicker(this.datepickerOptions);
        }
    }
    // 	 this.$el.datetimepicker(this.datepickerOptions);
    // this.isLoaded = true;

}